<template>
    <div class="handle-box-search">
        <div class="fuliguan">
            <div class="status-btn">
                <span>福利官功能开启</span>
                <div style="margin-left: 10px">{{submit_data.status}}
                    <el-switch v-model="submit_data.status" inactive-text="" active-value="1" inactive-value="0"> </el-switch>
                </div>
            </div>
            <div v-if="submit_data.status == 1" style="margin-top: 20px">
                <div class="coupon">
                    <span>优惠券:</span>

                    <el-select
                        v-model="value_coupon_code"
                        placeholder="请选择优惠券"
                        @visible-change="couponList"
                        @change="couponChange"
                        clearable
                        style="position: relative; width: 150px; margin-left: 10px"
                    >
                        <el-option v-for="item in options_coupon_code" :key="item.value" :label="item.name" :value="item.coupon_mode_code">
                        </el-option>

                        <el-pagination
                            class="pagination"
                            layout="prev, pager, next"
                            :total="selectPages_coupon_data.count"
                            :page-size="coupon_options_data.limit"
                            @current-change="selectPages_coupon_function"
                            :current-page="coupon_options_data.page"
                        />
                    </el-select>
                </div>
                <div class="erWei">
                    <span>企业微信二维码:</span>
                    <div>
                        <el-image
                        :preview-src-list="srcList"
                        v-if="img_url.wechat_img_url"
                        :src="img_url.wechat_img_url"
                        class="avatar"
                    ></el-image>
                    <el-upload
                        :class="img_url.wechat_img_url ? 'border-none' : ''"
                        class="avatar-uploader"
                        :action="img_upload_url"
                        :show-file-list="false"
                        :before-upload="idPortraitSuccess"
                        :headers="img_headers"
                    >
                        <el-button
                            slot="trigger"
                            v-if="img_url.wechat_img_url"
                            @click="img_url.wechat_img_url = ''"
                            style="width: 220px; margin-top: 10px"
                            >更换图片</el-button
                        >
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>

                    </div>

                </div>

            </div>
        </div>

        <!-- 对话框底部按钮 -->
        <div style="display: flex; justify-content: center;margin-top:10px">
            <el-button type="primary" @click="onSubmitDig">保存</el-button>

        </div>
    </div>
</template>
<script>
var _this;
import { config } from '../../../utils/config'; // 配置

export default {
    data() {
        return {
            // 图片上传地址
            img_upload_url: '',
            // 上传图片的请求头
            img_headers: {
                token: '',
                'hash-key': '',
                platform: 'pc',
                'app-version': 'admin',
                port: 'admin',
                'city-tag': localStorage.getItem('city_tag'),
                'service-tag':localStorage.getItem('service_tag')
            },
            status: 0,
            srcList: [],
            //展示图片的图片地址
            img_url: {
                wechat_img_url: ''
            },
            value_coupon_code: '',
            options_coupon_code: [],
            selectPages_coupon_data: [],
            coupon_options_data: {
                page: 1,
                limit: 5,
                status: 1
            },

            submit_data: {
                status: 0,
                wechat_img: '',
                coupon_mode_code: ''
            },
            submit_rules: {
                wechat_img: {
                    placeholder: '企业微信二维码',
                    rules: {
                        required: true,
                        message: '企业微信二维码哈希值错误',
                        regulation: 'lt_str',
                        rulesData: 'json_array'
                    }
                },
                coupon_mode_code: {
                        placeholder: '请选择优惠券',
                        rules: {
                            required: false,
                            message: '优惠券',
                            regulation: 'gt_str',
                            rulesData: '0'
                        }

                    }
            }
        };
    },
    created() {
        _this = this;
        _this.details();
    },
    methods: {
        selectPages_coupon_function(search_data) {
            _this.coupon_options_data.page = search_data;

            _this.couponList();
        },
        couponChange(val) {
            _this.submit_data.coupon_mode_code = val;
        },
        couponList() {
            _this
                .$post('/coupon/CouponModeLists', _this.coupon_options_data)
                .then((res) => {
                    _this.selectPages_coupon_data = res;
                    _this.options_coupon_code = res.data;
                })
                .catch((err) => {});
        },
        // 图片上传成功后执行  两个参数，file代表上传的文件，isSave代表上传的policyName参数是临时文件还是永久文件。permanent（永久文件）temporary（临时文件）
        idPortraitSuccess(file) {
            _this.$uploadImage({ file: file, isSave: 'permanent' }).then((res) => {
                // console.log(file, '1============');
                console.log(res, 'res');

                // 将返回的哈希值存到submit_data对象
                _this.submit_data.wechat_img = res.hash;

                // 设置img标签显示的图片路径
                _this.img_url.wechat_img_url = URL.createObjectURL(file);

                //上传图片后点击预览
                _this.srcList.push(String(_this.img_url.wechat_img_url));
            });

            return false;
        },
        // 提交
        onSubmitDig() {

            console.log(_this.submit_data.status,'_this.submit_data.status');
            if (_this.submit_data.status == "1") {
                _this.submit_rules.coupon_mode_code.rules.required = true;
            } else {
                _this.submit_rules.coupon_mode_code.rules.required = false;
            }
            _this.$post('/fuliguan/edit', _this.submit_data, _this.submit_rules).then((res) => {
                console.log(2222);
                _this.$message.success('操作成功！');
                _this.details();
            });
        },

        details() {
            _this.$post('/fuliguan/details').then((res) => {
                _this.submit_data.status = res.data.status;
                _this.submit_data.coupon_mode_code = res.data.coupon_mode_code;
                _this.value_coupon_code = res.data.coupon_mode_name;

                _this.submit_data.wechat_img = res.data.wechat_img;
                _this.img_url.wechat_img_url = res.data.wechat_img_url;
                _this.srcList.length = 0;
                _this.srcList.push(_this.img_url.wechat_img_url);
                // 获取上传图片的地址
                _this.img_upload_url = config.axios_imgURL;
            });
        }
    }
};
</script>
<style scoped>

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 220px;
    height: 220px;
    display: block;
}

.avatar-uploader {
    width: 220px;
    height: 220px;
}

.avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;
}
.handle-box-search {
    background-color: #fff !important;
}
.status-btn {
    width: 220px;
    display: flex;

    margin-top: 10px;

}
.fuliguan {
    width: 50%;
    margin: 0 auto;
    color: black;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;



}
.coupon {
    width: 100%;

}
.erWei {
    width: 100%;
    margin-top: 20px;

}

</style>